import GradeLessonPage from '../components/GradeLessonPage';
import { grade9Part1Topics } from './data-part1';
import { grade9Part2Topics } from './data-part2';
import { grade9Part3Topics } from './data-part3';
import { grade9Part4Topics } from './data-part4';

const allTopics = [
  ...grade9Part1Topics,
  ...grade9Part2Topics,
  ...grade9Part3Topics,
  ...grade9Part4Topics,
];

const topics = allTopics.map((topic: any) => ({
  id: topic.id,
  title: topic.title,
  icon: topic.icon,
  color: topic.color,
  skills: (topic.skills ?? []).map((skill: any) => ({
    id: skill.id,
    title: skill.title,
    standards: skill.standards ?? [],
    explanation: skill.explanation ?? '',
    questions: (skill.questions ?? []).map((q: any) => ({
      q: q.q ?? '',
      steps: q.steps ?? [],
      answer: q.answer ?? '',
    })),
  })),
}));

export default function Grade9Page() {
  return (
    <>
      <GradeLessonPage
        grade="Grade 9 / Algebra 1"
        gradeLabel="Grade 9"
        gradeColor="orange"
        topics={topics}
        prevGrade={{ label: 'Grade 8', path: '/grade/8' }}
        nextGrade={{ label: 'Geometry', path: '/geometry' }}
      />
      
      {/* Grade 9 Resources Quick Links */}
      <div className="bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-slate-900 mb-2">Grade 9 Resources</h2>
            <p className="text-lg text-slate-600">Additional tools to support your Algebra 1 journey</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            <a
              href="/grade-9-worksheets"
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all group cursor-pointer"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg mb-4 group-hover:scale-110 transition-transform mx-auto">
                <i className="ri-file-list-3-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 text-center">Browse Worksheets</h3>
              <p className="text-slate-600 text-center mb-4">36+ topic-specific printable drills organized by domain</p>
              <div className="flex items-center justify-center gap-2 text-indigo-600 font-medium">
                <span>Explore Worksheets</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>

            <a
              href="/grade-9-study-plan"
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all group cursor-pointer"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-green-500 to-teal-600 rounded-lg mb-4 group-hover:scale-110 transition-transform mx-auto">
                <i className="ri-calendar-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 text-center">Study Plan</h3>
              <p className="text-slate-600 text-center mb-4">Personalized weekly schedule mapping topics to your timeline</p>
              <div className="flex items-center justify-center gap-2 text-green-600 font-medium">
                <span>Create Plan</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>

            <a
              href="/grade-9-progress"
              className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all group cursor-pointer"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-lg mb-4 group-hover:scale-110 transition-transform mx-auto">
                <i className="ri-bar-chart-box-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2 text-center">Progress Tracker</h3>
              <p className="text-slate-600 text-center mb-4">Mark completed worksheets and visualize your mastery</p>
              <div className="flex items-center justify-center gap-2 text-purple-600 font-medium">
                <span>Track Progress</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}